import React from 'react';
import { Col, Container } from 'react-bootstrap';
import { TopMenu } from '../../shared';

function Rti() {

  return (
    <>
      <TopMenu />

      <Col lg={12} className='inner-bg'>
        <Container className='middle-content'>
          <div className="page-heading">
            <img src='https://pmfby.amnex.co.in/pmfby/lms/lms-inner-banner.jpg' alt='Inner Banner - LMS' className='img-fluid pb-4' />
            <h4 className="fw-bold mb-2">RTI (Right to Information)</h4>
            <ul className="my-topbreadcrum">
              <li>
                <a
                  href="/lms"

                >Home</a>
              </li>
              &nbsp; / &nbsp;
              <li>RTI</li>
            </ul>
          </div>
          <div>
            <p><strong>Central Information Commission</strong></p>
            <p>The Government of India lays emphasis on making the lives of its citizens easy and smooth. It aims to make India truly democratic and keeping this in mind, the RTI Act has been established.
            </p>
            <p>
              RTI stands for ‘Right To Information’ and has been given the status of a fundamental right under Article 19(1) of the Constitution. Article 19 (1) under which every citizen has freedom of speech and expression and have the right to know how the government works, what role does it play, what are its functions and so on.</p>

            <p>
              RTI Act confers right to access to information held by a Public Authority. In case,you have been denied the access to information you may file Appeal / Complaint before the Central Information Commission (CIC) using the CIC Online.</p>

            <p><a href='https://cic.gov.in/' target='_blank'>Click Here For more Information</a></p>
          </div>
        </Container>
      </Col>
    </>
  );
}

export default Rti;